function storeLocator(){
    const options = window.document.querySelectorAll('.js_locator-option');
    const selectedValue = window.document.querySelector('.js_locator-selected-value');

    if(options.length < 1 || !selectedValue) return;

    const hideSelectedOption = () => {
        options.forEach(opt=>{
        if (opt.getAttribute("data-value") == selectedValue.value)
            opt.parentElement.style.display = 'none'
        else
            opt.parentElement.style.display = 'list-item'
        })
    }

    options.forEach(option => {
        if (option.getAttribute("data-value") == selectedValue.value)
            option.parentElement.style.display = 'none'
        else
            option.parentElement.style.display = 'list-item'

        option.addEventListener("click",function(e){
            e.preventDefault();
            const value = this.getAttribute("data-value");
            const storesCard = window.document.querySelectorAll('.js_store-card');
            if (storesCard.length < 1) return;

            selectedValue.value = value;

            hideSelectedOption();

            storesCard.forEach(store =>{
                const country = store.getAttribute("data-locator-country");

                if (value === country){
                    // mostro store
                    store.classList.remove('hide-store');
                    store.classList.add('show-store');
                    store.style.display="flex";
                }
                else if (value !== "All"){
                    //nascondo store
                    store.classList.add('hide-store');
                    //setTimeout(()=>{
                        store.style.display="none";
                    //},150)
                }
                else{
                    // mostro store
                    store.classList.remove('hide-store');
                    store.classList.add('show-store');
                    store.style.display="flex";                  
                }
            })
        })
    })
}
window.addEventListener('load',storeLocator);